import { currentLang } from './lang';
import { routePaths } from '../apps/store-locator/router/paths';
import routesMetaData from '../apps/store-locator/router/routes-meta-data';
export const routeNameByUrl = (url) => {
    const currentLocale = currentLang();
    const route = Object.entries(routePaths).find(path => {
        const [pathName, pathLocales] = path;
        return pathLocales[currentLocale] === url;
    });
    if (!route) {
        return '';
    }
    return route[0];
};
export const parentUrlByUrl = (url) => {
    const routeName = routeNameByUrl(url);
    const currentLocale = currentLang();
    if (!routeName) {
        return '/';
    }
    const route = Object.entries(routesMetaData).find(path => {
        const [pathName] = path;
        return pathName === routeName;
    });
    if (!route) {
        return '/';
    }
    const { parentRouteName } = route[1];
    const parentRoute = Object.entries(routePaths).find(path => {
        const [pathName] = path;
        return pathName === parentRouteName;
    });
    if (!parentRoute) {
        return '/';
    }
    return parentRoute[1][currentLocale];
};
